import { render, staticRenderFns } from "./BidFilter.vue?vue&type=template&id=21679e63&"
import script from "./BidFilter.vue?vue&type=script&lang=js&"
export * from "./BidFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports